(ns dashboard.components.flash-screen)

(defn flash-screen []
  [:section.hero.is-fullheight.is-splash {:style {:position "fixed"
                                                  :top 0
                                                  :left 0
                                                  :width "100vw"
                                                  :height "100vh"}}
   [:div.hero-body>div.container.is-flex.has-text-centered.has-text-dark
    {:style {:align-items     "center"
             :justify-content "center"}}
    [:img {:src "/img/repliance-logo.svg" :width "auto" :height 45}]
    [:div.loader.ml-3
     {:style {:border-width        "3px"
              :border-left-color   "#02585D"
              :border-bottom-color "#02585D"
              :height              "20px"
              :width               "20px"}}]]])
